<template>
  <div class="row model-settings" :class="{ 'model-settings--nested': !!parent }">
    <template
      v-for="(field, index) in fields"
      :key="`${parent}-${field.name}-${index}`"
    >
      <div v-if="field.type === 'group'" class="col-12 field-group">
        <!-- <div class="row"> -->
        <div class="d-flex align-items-center">
          <h4>{{ field.label }}</h4>
        </div>
        <template v-if="getChildren(field)">
          <SchemaGroup
            :id="`parent-${field.name}`"
            v-model:params="parameters[field.name]"
            :fields="field.children"
            :parent="field.name"
            :defaultValues="defaultValues"
          />
        </template>
        <!-- </div> -->
      </div>
      <div v-if="field.type === 'slider'" class="col-12 form__control-group field-group">
        <label :class="{'required': field.required}" :for="`slider-input-${parent}-${field.name}`">
          {{ field.label }}
          <SVGIcon
            v-if="field.description"
            v-tooltip="field.description"
            :iconName="'info-square'"
            class="info-icon"
          />
          <span class="slider-value">{{ parameters[field.name] }}</span>
        </label>
        <div class="slider-container">
          <SingleSlider
            v-if="field.values === 1 && parameters[field.name] !== null"
            :id="`slider-input-${parent}-${field.name}`"
            v-model:sliderValue="parameters[field.name]"
            :step="field.step"
            :min="field.min"
            :max="field.max"
          />
          <RangeSlider
            v-else-if="field.values === 2 && parameters[field.name] !== null"
            :id="`slider-input-${parent}-${field.name}`"
            v-model:valueLower="parameters[field.name][0]"
            v-model:valueUpper="parameters[field.name][1]"
            :step="field.step"
            :min="field.min"
            :max="field.max"
            :showMiddle="false"
          />
          <SingleSlider
            v-else-if="parameters[field.name] !== null"
            :id="`slider-input-${parent}-${field.name}`"
            v-model:sliderValue="parameters[field.name]"
            :step="field.step"
            :min="field.min"
            :max="field.max"
          />
        </div>
      </div>
      <template v-if="typeof parameters[field.name] === 'string' || typeof parameters[field.name] === 'number' || Array.isArray(parameters[field.name])">
        <div v-if="field.type === 'select'" class="col-12 form__control-group field-group">
          <label :class="{'required': field.required}" :for="`int-input-${parent}-${field.name}`">
            {{ field.label ? field.label : field.Label ? field.Label : field.name }}
            <SVGIcon
              v-if="field.description"
              v-tooltip="field.description"
              :iconName="'info-square'"
              class="info-icon"
            />
          </label>
          <select
            v-if="field.is_dropdown"
            :id="`select-input-${parent}-${field.name}`"
            v-model="parameters[field.name]"
            class="select"
          >
            <option
              v-for="(option, i) in field.options"
              :key="`dropdown-${parent}-${field.name}-${i}-${option.name}`"
              :value="option.name"
            >
              {{ option.label }}
            </option>
          </select>
          <div v-else class="row radio-option">
            <div v-for="(option, i) in field.options" :key="i" class="radio-option__field">
              <input
                :id="`radio-${parent}-${field.name}-${i}-${option.name}`"
                v-model="parameters[field.name]"
                :type="field.multi_select ? 'checkbox' : 'radio'"
                :value="option.name"
              >
              <label :for="`radio-${parent}-${field.name}-${i}-${option.name}`">{{ option.label }}</label>
            </div>
          </div>
          <template v-if="getSelectChildren(field)">
            <SchemaGroup
              :id="`parent-${field.name}`"
              v-model:params="parameters[field.name]"
              :fields="getSelectChildren(field)"
              :parent="field.name"
              :defaultValues="defaultValues"
            />
          </template>
        </div>
      </template>
      <template v-else-if="typeof parameters[field.name] === 'object'">
        <div v-if="field.type === 'select'" class="col-12 form__control-group field-group">
          <label :class="{'required': field.required}" :for="`select-object-input-${parent}-${field.name}`">
            {{ field.label ? field.label : field.Label ? field.Label : field.name }}
            <SVGIcon
              v-if="field.description"
              v-tooltip="field.description"
              :iconName="'info-square'"
              class="info-icon"
            />
          </label>
          <select
            v-if="field.is_dropdown"
            :id="`select-object-input-${parent}-${field.name}`"
            class="select"
            @change="getSelectValue($event.target.value, field)"
          >
            <option
              v-for="(option, i) in field.options"
              :key="`dropdown-${parent}-${field.name}-${i}-${option.name}`"
              :value="option.name"
            >
              {{ option.label }}
            </option>
          </select>
          <div v-else class="row radio-option">
            <div v-for="(option, i) in field.options" :key="i" class="radio-option__field">
              <input
                :id="`radio-${parent}-${field.name}-${i}-${option.name}`"
                :type="field.multi_select ? 'checkbox' : 'radio'"
                :value="option.name"
                @input="($event) => getSelectValue($event.target.value, field)"
              >
              <label :for="`radio-${parent}-${field.name}-${i}-${option.name}`">{{ option.label }}</label>
            </div>
          </div>

          <template v-if="getSelectChildren(field)">
            <SchemaGroup
              v-for="childKey in Object.keys(parameters[field.name])"
              :id="`parent-${field.name}`"
              :key="childKey"
              v-model:params="parameters[field.name][childKey]"
              :fields="getSelectChildren(field)"
              :parent="field.name"
              :defaultValues="defaultValues"
            />
          </template>
        </div>
      </template>
      <div v-if="field.type === 'bool' && 'children' in field" class="col-12 field-group">
        <div class="row">
          <div class="col-12 form__control-group checkbox-container">
            <input
              :id="`checkbox-children-${parent}-${field.name}`"
              :name="`checkbox-children-${parent}-${field.name}`"
              type="checkbox"
              :checked="field.name in parameters"
              @input="($event) => getBooleanValue($event, field)"
            >
            <label class="ms-2" :class="{'required': field.required}" :for="`checkbox-children-${parent}-${field.name}`">
              {{ field.label }}
              <SVGIcon
                v-if="field.description"
                v-tooltip="field.description"
                :iconName="'info-square'"
                class="info-icon"
              />
            </label>
          </div>
        </div>
        <keep-alive>
          <template v-if="field.name in parameters">
            <div class="row">
              <div class="col-12">
                <SchemaGroup
                  :id="`parent-${field.name}`"
                  v-model:params="parameters[field.name]"
                  :fields="field.children"
                  :parent="field.name"
                  :defaultValues="defaultValues"
                />
              </div>
            </div>
          </template>
        </keep-alive>
        <!-- </div> -->
      </div>
      <div v-else-if="field.type === 'bool'" class="col-12 form__control-group checkbox-container field-group">
        <input
          :id="`checkbox-${parent}-${field.name}`"
          :name="`checkbox-${parent}-${field.name}`"
          type="checkbox"
          :checked="parameters[field.name]"
          @input="($event) => getBooleanValue($event, field)"
        >
        <label class="ms-2" :class="{'required': field.required}" :for="`checkbox-${parent}-${field.name}`">
          {{ field.label }}
          <SVGIcon
            v-if="field.description"
            v-tooltip="field.description"
            :iconName="'info-square'"
            class="info-icon"
          />
        </label>
      </div>
      <div v-if="field.type === 'int'" class="col-12 form__control-group field-group">
        <label :class="{'required': field.required}" :for="`int-input-${parent}-${field.name}`">
          {{ field.label }}
          <SVGIcon
            v-if="field.description"
            v-tooltip="field.description"
            :iconName="'info-square'"
            class="info-icon"
          />
        </label>
        <input
          :id="`int-input-${parent}-${field.name}`"
          v-model="parameters[field.name]"
          type="number"
          :step="field.step"
          :min="field.min"
          :max="field.max"
        >
      </div>
      <div v-if="field.type === 'float'" class="col-12 form__control-group field-group">
        <label :class="{'required': field.required}" :for="`float-input-${parent}-${field.name}`">
          {{ field.label }}
          <SVGIcon
            v-if="field.description"
            v-tooltip="field.description"
            :iconName="'info-square'"
            class="info-icon"
          />
        </label>
        <input
          :id="`float-input-${parent}-${field.name}`"
          v-model="parameters[field.name]"
          type="number"
          :step="field.step"
          :min="field.min"
          :max="field.max"
        >
      </div>
      <div v-if="field.type === 'text'" class="col-12 form__control-group field-group">
        <label :class="{'required': field.required}" :for="`text-input-${parent}-${field.name}`">
          {{ field.label }}
          <SVGIcon
            v-if="field.description"
            v-tooltip="field.description"
            :iconName="'info-square'"
            class="info-icon"
          />
        </label>
        <textarea
          v-if="field.is_multi_line"
          :id="`text-input-${parent}-${field.name}`"
          v-model="parameters[field.name]"
          rows="4"
          cols="50"
        />
        <input
          v-else
          :id="`text-input-${parent}-${field.name}`"
          v-model="parameters[field.name]"
          :type="field.hidden ? 'password' : field.numeric_only ? 'number' : 'text'"
        >
      </div>
      <div v-if="field.type === 'date'" class="col-12 form__control-group field-group">
        <label :class="{'required': field.required}" :for="`date-input-${parent}-${field.name}`">
          {{ field.label }}
          <SVGIcon
            v-if="field.description"
            v-tooltip="field.description"
            :iconName="'info-square'"
            class="info-icon"
          />
        </label>
        <input
          :id="`date-input-${parent}-${field.name}`"
          v-model="parameters[field.name]"
          type="date"
        >
      </div>

      <div v-if="field.type === 'project'" class="col-12 form__control-group field-group">
        <SchemaProjects v-model="parameters[field.name]" :field="field" :parent="parent" />
      </div>

      <div v-if="field.type === 'experiment'" class="col-12 form__control-group field-group">
        <SchemaExperiment
          v-model="parameters[field.name]"
          :field="field"
          :parent="parent"
          :projectId="parameters.dataset?.project_id || parameters.project_id || defaultValues?.dataset?.project_id || defaultValues?.project_id || 0"
        />
      </div>

      <div v-if="field.type === 'snapshot'" class="col-12 form__control-group field-group">
        <SchemaSnapshot
          v-model="parameters[field.name]"
          :field="field"
          :parent="parent"
          @update:snapshotId="(val) => { parameters.snapshot_id = val; }"
        />
      </div>

      <div v-if="field.type === 'dataset'" class="col-12 form__control-group field-group">
        <SchemaDatasets 
          v-model="parameters[field.name]" 
          :schemaField="field" 
          :parent="parent"
          :enableProjectSelection="true"
          :enableTagsSelection="field.enable_tags_selection ? true : false"
          :enableAnnotationSetSelection="field.enable_annotation_set_selection ? true : false"
          :enableGroupSelection="field.enable_group_selection ? true : false"
          :tagName="parameters[field.name]?.tagName || ''"
          :trainGroupName="parameters[field.name]?.trainGroupName || ''"
          :valGroupName="parameters[field.name]?.valGroupName || ''"
          :defaultValues="defaultValues?.dataset || {}"
          @update:tagName="(val) => { if (!parameters[field.name]) parameters[field.name] = {}; parameters[field.name].tagName = val; }"
          @update:trainGroupName="(val) => { if (!parameters[field.name]) parameters[field.name] = {}; parameters[field.name].trainGroupName = val; }"
          @update:valGroupName="(val) => { if (!parameters[field.name]) parameters[field.name] = {}; parameters[field.name].valGroupName = val; }"
        />
      </div>
      
      <div v-if="field.type === 'trainer'" class="col-12 form__control-group field-group">
        <SchemaTrainer 
          v-model="parameters[field.name]" 
          :defaultValues="defaultValues?.trainer || {}"  
          :field="field" 
          :parent="parent" />
      </div>

      <div v-if="field.type === 'upload'" class="col-12 form__control-group field-group">
        <UploadFiles v-model="parameters['folder']" :field="field" :parent="parent" />
      </div>

    </template>
  </div>
</template>

<script setup>
import {
  ref, watch, toRefs, onBeforeMount, onActivated,
} from 'vue';
import SingleSlider from '@/components/SingleSlider.vue';
import RangeSlider from '@/components/RangeSlider.vue';
import SVGIcon from '@/components/SVGIcon.vue';
import SchemaDatasets from '@/components/Schema/SchemaDataset.vue';
import SchemaExperiment from '@/components/Schema/SchemaExperiment.vue';
import SchemaProjects from '@/components/Schema/SchemaProject.vue';
import SchemaSnapshot from '@/components/Schema/SchemaSnapshot.vue';
import SchemaTrainer from '@/components/Schema/SchemaTrainer.vue';
import UploadFiles from '@/components/Schema/UploadFiles.vue';
import { modelParamsToFormState } from '@/utils/trainerSessionClone';

const props = defineProps({
  parent: {
    type: String,
    default: "",
  },
  fields: {
    type: Object,
    default: () => {},
  },
  params: {
    type: [String, Object, Boolean],
    default: () => {},
  },
  defaultValues: {
    type: Object,
    default: () => ({}),
  },
});


const emit = defineEmits([
  'update:params',
  'validation-error',
]);

const {
  parent,
  fields,
  params,
} = toRefs(props);

const parameters = ref({});
watch(parameters, (value) => {
  emit('update:params', JSON.parse(JSON.stringify(value)));
}, { deep: true });

function getSelectChildren(field) {
  if (parameters.value && parameters.value[field.name] && field.options) {
    const options = field.options.find((e) => e.name === getSpecificValue(parameters.value[field.name]))?.children;
    return options;
  } else {
    return null;
  }
}

function getChildren(field) {
  if (field.children && field.children.length > 0) {
    return field.children;
  } else {
    return null;
  }
}

function getSpecificValue(val) {
  if (typeof val === 'string') {
    return val;
  } else if (typeof val === 'object') {
    return Object.keys(val)[0];
  } else {
    return '';
  }
}

function getBooleanValue(e, field) {
  const isChecked = e.target.checked;
  if (!('children' in field)) {
    parameters.value[field.name] = isChecked;
  } else if ('children' in field && !isChecked) {
    delete parameters.value[field.name];
  } else if ('children' in field && isChecked) {
    parameters.value[field.name] = {};
  }
}

function getSelectValue(optionName, field) {
  const option = field.options.find((e) => String(e.name) === String(optionName));
  const notSelectedOptions = field.options.filter((e) => String(e.name) !== String(optionName));
  if (option) {
    if (!('children' in option)) {
      if (parameters.value[field.name] && Array.isArray(parameters.value[field.name])) {
        const stringArray = parameters.value[field.name].map((e) => String(e));
        const arrIndex = stringArray.indexOf(option.name);
        if (arrIndex > -1) {
          parameters.value[field.name].splice(arrIndex, 1);
        } else {
          parameters.value[field.name].push(option.name);
        }
      } else {
        parameters.value[field.name] = optionName;
      }
    } else if ('children' in option) {
      if (!parameters.value[field.name]) {
        parameters.value[field.name] = {};
      }
      parameters.value[field.name][optionName] = {};
    }
  }
  // remove unselected field
  if (parameters.value[field.name] && (typeof parameters.value[field.name] === 'object') && !Array.isArray(parameters.value[field.name])) {
    if (notSelectedOptions && notSelectedOptions.length > 0) {
      notSelectedOptions.forEach((o) => {
        if (o.name in parameters.value[field.name]) {
          delete parameters.value[field.name][o.name];
        }
      });
    }
  }
}

function hasInitialParams(value) {
  return value && typeof value === 'object' && !Array.isArray(value) && Object.keys(value).length > 0;
}

function initializeParametersFromFields() {
  if (fields.value) {
    fields.value.forEach((field) => {
      if (field.type === 'float' || field.type === 'int') {
        parameters.value[field.name] = field.default;
      } else if (field.type === 'select') {
        if (field.multi_select) {
          parameters.value[field.name] = [];
          if (Array.isArray(field.default)) {
            field.default.forEach((v) => {
              if (typeof v === 'string' || typeof v === 'number') {
                getSelectValue(v, field);
              }
            });
          } else if (typeof field.default === 'string' || typeof field.default === 'number') {
            parameters.value[field.name].push({
              value: field.default,
              options: {},
            });
          }
        } else if (typeof field.default === 'string' || typeof field.default === 'number') {
          getSelectValue(field.default, field);
        }
      } else if (field.type === 'slider') {
        parameters.value[field.name] = field.default;
      } else if (field.type === 'snapshot') {
        if (field.default !== undefined && field.default !== null && field.default !== '') {
          parameters.value[field.name] = Number.parseInt(field.default, 10);
          parameters.value.snapshot_id = Number.parseInt(field.default, 10);
        }
      } else if (field.type === 'bool') {
        if (!('children' in field) && field.default) {
          parameters.value[field.name] = true;
        } else if (!('children' in field) && !field.default) {
          parameters.value[field.name] = false;
        } else if ('children' in field && field.default) {
          parameters.value[field.name] = {};
        }
      }
    });
  }
}

// expansion panels do not share the same dropdown, so this will let each child have its own dropdown
onBeforeMount(() => {
  if (hasInitialParams(params.value)) {
    parameters.value = modelParamsToFormState(
      JSON.parse(JSON.stringify(params.value)),
      fields.value,
    );
    // For snapshot-type fields: if snapshot_id exists in params but field.name isn't set, apply it
    if (Array.isArray(fields.value) && parameters.value.snapshot_id !== undefined) {
      fields.value.forEach((field) => {
        if (field.type === 'snapshot' && (parameters.value[field.name] === undefined || parameters.value[field.name] === null)) {
          parameters.value[field.name] = Number.parseInt(parameters.value.snapshot_id, 10) || null;
        }
      });
    }
  } else {
    initializeParametersFromFields();
  }
  emit('update:params', JSON.parse(JSON.stringify(parameters.value)));
});

onActivated(() => {
  emit('update:params', JSON.parse(JSON.stringify(parameters.value)));
});

function validateRequiredFields(fieldsToValidate = fields.value, paramsToValidate = parameters.value) {
  const missingFields = [];
  
  if (fieldsToValidate) {
    fieldsToValidate.forEach((field) => {
      const fieldLabel = field.label || field.Label || field.name;
      
      // Check if field is required
      if (field.required) {
        let value;
        
        // Special handling for upload fields which use 'folder' key
        if (field.type === 'upload') {
          value = paramsToValidate['folder'];
        } else {
          value = paramsToValidate[field.name];
        }
        
        // Check if field is missing or empty
        if (value === undefined || value === null || value === '') {
          missingFields.push(fieldLabel);
        }
        // Check for empty arrays (multi-select)
        else if (Array.isArray(value) && value.length === 0) {
          missingFields.push(fieldLabel);
        }
        // Check for empty objects (but not if it has nested children that might be valid)
        else if (typeof value === 'object' && !Array.isArray(value) && Object.keys(value).length === 0) {
          missingFields.push(fieldLabel);
        }
        // Check dataset fields for missing dataset_id or tag_name
        else if (field.type === 'dataset' && typeof value === 'object') {
          if (!value.dataset_id) {
            missingFields.push('Dataset');
          }
          if (field.enable_tags_selection && !value.tag_name) {
            missingFields.push('Tag');
          }
        }
        // Check trainer fields for missing session_id
        else if (field.type === 'trainer' && typeof value === 'object') {
          if (!value.session_id) {
            missingFields.push('Training Session');
          }
        }
      }
      
      // Recursively validate children in group fields
      if (field.type === 'group' && field.children && Array.isArray(field.children)) {
        const groupParams = paramsToValidate[field.name];
        if (groupParams && typeof groupParams === 'object') {
          const childMissingFields = validateRequiredFields(field.children, groupParams);
          missingFields.push(...childMissingFields);
        }
      }
      
      // Validate children in select fields with children
      if (field.type === 'select' && field.options) {
        field.options.forEach((option) => {
          if (option.children && Array.isArray(option.children)) {
            const selectValue = paramsToValidate[field.name];
            if (selectValue && typeof selectValue === 'object') {
              const selectedOptionParams = selectValue[option.name];
              if (selectedOptionParams && typeof selectedOptionParams === 'object') {
                const childMissingFields = validateRequiredFields(option.children, selectedOptionParams);
                missingFields.push(...childMissingFields);
              }
            }
          }
        });
      }
      
      // Validate children in boolean fields with children
      if (field.type === 'bool' && field.children && Array.isArray(field.children)) {
        const boolParams = paramsToValidate[field.name];
        if (boolParams && typeof boolParams === 'object') {
          const childMissingFields = validateRequiredFields(field.children, boolParams);
          missingFields.push(...childMissingFields);
        }
      }
    });
  }
  
  return missingFields;
}

defineExpose({
  validateRequiredFields,
});

</script>

<style lang="scss" scoped>

.model-settings--nested {
  padding-left: 20px;
}

.model-settings h4 {
  width: fit-content;
  margin-bottom: 0;
  font-size: 15px;
  white-space: nowrap;
  text-align: left;
  color: #250E81;
}

label {
  display: flex;
  align-items: center;
}

.radio-option {
  display: flex;
  align-items: center;

  &__field {
    display: flex;
    flex-direction: row;
    align-items: center;
    width: fit-content;
    min-width: 300px;
    // max-width: 150px;

    label {
      padding-left: 5px;
      color: #383c48;
      cursor: pointer;
      font-size: 15px;
      font-weight: 500;
    }
  }
}

input[type="radio"], input[type="checkbox"] {
    min-height: 18px;
    min-width: 18px;
    border: 0px !important;
    @include themify() {
      accent-color: themed('color-primary');
    }
  }

.color-input {
  padding: 4px;
}

.text-field {
  width: 100%;
  text-align: start;
  font-size: 16px;
  font-weight: 400;
  white-space: wrap;
  line-break: anywhere;
  color: var(--color-primary-600);
}

.slider-label-container {
  display: flex;
  flex-direction: row;
  width: 100%;
  justify-content: space-between;
}

.slider-label {
  display: flex;
  justify-content: space-between;
  div {
    display: flex;
    align-items: center;
    width: fit-content;
  }
}

.slider-value {
  margin-left: auto;
}

.checkbox-container {
  display: flex;
  flex-direction: row;
}

:deep() {
  .v-expansion-panel__shadow {
    box-shadow: none !important;
  }
  .v-expansion-panel-title--active {
    min-height: 0;
  }
  .v-expansion-panel-text{
    padding: 0 16px 0 16px !important;
  }
  .v-expansion-panel-text__wrapper{
    display: flex;
    justify-content: center;
    padding: 0 0 8px 0 !important;
  }
  .v-expansion-panel-title{
    min-height: 40px !important;
    height: 40px !important;
  }
}
.help-logo {
  margin: 0 5px;
  color: var(--color-primary);
}

.help-logo:focus {
  outline: none;
}

.field-group:not(:first-of-type) {
  margin-top: 8px;
}

</style>
